import React from 'react'

export default function ModeAir({ style, svgStyle }: any) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgStyle}
    >
      <path
        fill="#212121"
        {...style}
        d="M19.3181 2.51885L15.0103 6.82673L3.38913 3.30257L2.0293 4.66244L10.9307 10.9064L6.75341 15.0825L3.28171 14.2304L2 15.5098L5.90016 18.1013L8.49045 22.0003L9.77098 20.7198L8.91898 17.2469L21.4824 4.68197L22 2L19.3181 2.51885Z"
      />
      <path
        fill="#212121"
        {...style}
        d="M13.599 13.7898L19.3375 21.971L20.6974 20.6111L17.4588 9.92856L13.599 13.7898Z"
      />
    </svg>
  )
}
